import React from 'react';
import PropTypes from 'prop-types'

import css from './Header.module.scss'

const Header = ({text}) => {
  return (
    <div className={css.header}>{text}</div>
  )
}

Header.propTypes = {
  text: PropTypes.string
}

Header.defaultProps = {
  text: ''
}

export default Header;
